import request from './request'
import { buildOAuthRedirectUrl, getWechatSpaBase } from '../utils/wechatOAuth'

/**
 * 获取第三方数据（部门/人员）
 * @param {string} type - 数据类型：dept-部门，user-人员
 * @returns {Promise<Array>}
 */
export const getThirdData = (type) => {
  return request({
    url: '/visitor/third/data',
    method: 'get',
    params: { type },
    silent: true
  })
}

/**
 * H5 可选访问公司（workflow_info 启用行）
 * @returns {Promise<Array<{ companyName: string, sortOrder: number }>>}
 */
export const getWorkflowHostCompanies = () => {
  return request({
    url: '/visitor/workflow-host-companies',
    method: 'get',
    silent: true
  })
}

/**
 * 按接待人姓名精确匹配本地人员及部门（服务端查库）
 * @param {string} name
 * @returns {Promise<Array<{ id, name, departmentId, departmentName }>>}
 */
export const matchReceptionUsers = (name) => {
  return request({
    url: '/visitor/third/match-reception-users',
    method: 'get',
    params: { name: name != null ? String(name) : '' },
    silent: true
  })
}

/**
 * 当前 openid 下近期访客登记与审核（供审核结果弹层轮询）
 * @param {string} openid
 * @returns {Promise<Array>}
 */
export const getMyVisitRecords = (openid) => {
  return request({
    url: '/visitor/my-records',
    method: 'get',
    params: { openid },
    silent: true
  })
}

/**
 * 提交访客登记信息
 * @param {Object} data - 登记信息
 * @returns {Promise<number>}
 */
export const submitVisitor = (data) => {
  return request({
    url: '/visitor/submit',
    method: 'post',
    data
  })
}

/**
 * 获取微信授权链接
 * @param {string} redirectUrl - 授权成功后跳转地址
 */
export const getAuthUrl = (redirectUrl) => {
  const u = redirectUrl != null && redirectUrl !== '' ? redirectUrl : buildOAuthRedirectUrl()
  const apiBase = getWechatSpaBase()
  window.location.href = `${apiBase}/api/wechat/authorize?redirectUrl=${encodeURIComponent(u)}`
}

/**
 * 通过code获取openid
 * @param {string} code - 微信授权code
 * @returns {Promise<string>}
 */
export const getOpenid = (code) => {
  return request({
    url: '/wechat/getOpenid',
    method: 'get',
    params: { code }
  })
}

/**
 * 拉取 JSSDK 签名；url 为当前页完整地址且不含 # 后内容（与微信签名规范一致）
 */
export const getWechatJssdkConfig = (url) => {
  return request({
    url: '/wechat/jssdk-config',
    method: 'get',
    params: { url },
    silent: true
  })
}
